import { goalbookUrls } from '@/links'

const agenticSearchHost = goalbookUrls.growApi

export async function createTask(formData) {
  const response = await fetch(`${agenticSearchHost}/toolkit-agent/agent/create`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  })

  if (response.status >= 200 && response.status < 300) {
    const responseJSON = await response.json()
    return responseJSON
  }

  let responseBody
  try {
    responseBody = await response.json()
  } catch (error) {
    responseBody = await response.text()
  }

  const error = new Error(`Failed to create task: HTTP ${response.status}`)
  error.status_code = response.status
  error.response_json = responseBody
  throw error
}

export function runAgent(taskId, onMessage, onError, onComplete) {
  const url = `${agenticSearchHost}/toolkit-agent/agent/run/${taskId}`
  let reader = null
  let isClosed = false

  const promise = (async () => {
    try {
      const response = await fetch(url, {
        credentials: 'include',
      })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

      reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''

      const processLine = (line) => {
        if (line.startsWith('data: ')) {
          try {
            const jsonStr = line.slice(6)
            const data = JSON.parse(jsonStr)

          if (data.type === 'error') {
            if (onError) onError(data)
            if (onComplete) onComplete()
            try {
              reader.cancel()
            } catch (error) {
              console.error('Error cancelling reader:', error)
            }
            return true
          }

            try {
              onMessage(data)
            } catch (error) {
              console.error('Error in onMessage callback:', error, 'Data:', data)
              if (onError) onError(error)
              return true
            }

            if (data.type === 'completed') {
              if (onComplete) onComplete()
              try {
                reader.cancel()
              } catch (error) {
                console.error('Error cancelling reader:', error)
              }
              return true
            }
          } catch (error) {
            console.error('Error parsing SSE message:', error, 'Line:', line)
            if (onError) onError(error)
          }
        }
        return false
      }

      while (!isClosed) {
        const { done, value } = await reader.read()
        if (done) break

      buffer += decoder.decode(value, { stream: true })
      const lines = buffer.split('\n')
      buffer = lines.pop() || ''

      for (const line of lines) {
        if (processLine(line)) return
      }
    }

    if (buffer.trim()) {
      if (processLine(buffer)) return
    }

      if (onComplete) onComplete()
    } catch (error) {
      console.error('SSE connection error:', error)
      if (onError) onError(error)
      if (onComplete) onComplete()
    }
  })()

  promise.close = function() {
    isClosed = true
    if (reader) {
      try {
        reader.cancel()
      } catch (error) {
        console.error('Error cancelling reader:', error)
      }
    }
  }

  return promise
}
